import { fetchCarMarkOptions, fetchCarTypeOptions } from '@/shared/api/car';
import type { ListFilter } from '@/shared/ui/list/types';

export const typeFilter: ListFilter = {
  name: 'type_id',
  label: 'Фильтрация по типу',
  kind: 'select',
  loadOptions: () => fetchCarTypeOptions(),
};

export const markFilter: ListFilter = {
  name: 'mark_id',
  label: 'Фильтрация по марке выбранного типа',
  kind: 'select',
  dependsOn: 'type_id',
  loadOptions: fetchCarMarkOptions,
};
